import { CmsSignupIntentOption } from 'signup-constants/signupData/CmsOption';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { Data } from '../../signup-data/DATA';
import { Step } from '../../views/Step';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
export const BranchCmsBusinessMaturity = {
  name: 'BranchCmsBusinessMaturity',
  stateCheck: state => {
    const cmsSignupIntentValue = getSignupDataValue(state, Data.CmsSignupIntent);
    return cmsSignupIntentValue === CmsSignupIntentOption.Personal;
  },
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(FlowStateManager.removeSteps([Step.CmsBusinessMaturity], false));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};